/**
 * @generated SignedSource<<834c3119f3bb27927cc8964c85967f09>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateMediaFactoryEmbedInput = {
  appId: number;
};
export type aiCustomAppsCreateMediaFactoryEmbedMutation$variables = {
  input: CreateMediaFactoryEmbedInput;
};
export type aiCustomAppsCreateMediaFactoryEmbedMutation$data = {
  readonly createMediaFactoryEmbed: {
    readonly expiresAt: string | null;
    readonly frontendUrl: string;
    readonly jti: string;
    readonly sdkUrl: string;
    readonly token: string;
    readonly workflowExternalId: string | null;
  };
};
export type aiCustomAppsCreateMediaFactoryEmbedMutation = {
  response: aiCustomAppsCreateMediaFactoryEmbedMutation$data;
  variables: aiCustomAppsCreateMediaFactoryEmbedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MediaFactoryEmbedPayload",
    "kind": "LinkedField",
    "name": "createMediaFactoryEmbed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jti",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "expiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "frontendUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sdkUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "workflowExternalId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsCreateMediaFactoryEmbedMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsCreateMediaFactoryEmbedMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "5eac5a74405358c9bdcb0ef91fa06597",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsCreateMediaFactoryEmbedMutation",
    "operationKind": "mutation",
    "text": "mutation aiCustomAppsCreateMediaFactoryEmbedMutation(\n  $input: CreateMediaFactoryEmbedInput!\n) {\n  createMediaFactoryEmbed(input: $input) {\n    token\n    jti\n    expiresAt\n    frontendUrl\n    sdkUrl\n    workflowExternalId\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9c74fcbde1a7d77adf8a43d883d8773";

export default node;
